export function getSectionName(book, isReturnTrip, isArrivalDisplay) {
  if (!book.price) {
    return "";
  }
  const price = book.price;
  if (isReturnTrip || isArrivalDisplay) {
    return price.to_station?.name || "";
  }
  return price.from_station?.name || "";
}

export function getSectionSuffix(book, isReturnTrip, isArrivalDisplay) {
  if (!book.price) {
    return "";
  }
  const price = book.price;
  if (isArrivalDisplay) {
    return "まで";
  }
  const isFromStationUnset = price.from_station?.code === -1;
  if (!isReturnTrip && isFromStationUnset) {
    return "";
  }
  return "から";
}
